<template>
    <div>
        <div id="passType" class="pass">
            <h3>{{ passType.id ? 'Edit' : 'Create' }} Pass Type</h3>
            <b-row>
                <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Name" description="As shown in NSID">
                        <b-form-input v-model="passType.name" type="text" placeholder="Pass Type Name"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Price">
                        <b-form-input v-model="passType.price" type="number" placeholder="Price"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Type">
                        <b-form-select v-model="passType.type" :options="typeOptions" class="mb-3" />
                    </b-form-group>
                    <b-form-group v-if="isAdmin" label="SKUs" description="Comma-separated SKUs (e.g. SKU1, SKU2, SKU3)">
                        <b-form-input v-model="skuInput" type="text" placeholder="Enter SKUs"
                            @input="updateSkuTags"></b-form-input>
                        <div class="mt-2">
                            <b-badge v-for="(sku, index) in skuTags" :key="index" variant="info" class="mr-1">
                                {{ sku }}
                            </b-badge>
                        </div>
                    </b-form-group>

                    <b-form-group label="Age">
                        <b-form-select v-model="passType.age" :options="ageOptions" class="mb-3" />
                    </b-form-group>
                    <b-form-group v-show="!isSeasonPass" label="Days Limit" description="e.g. '7' for 7 day pass">
                        <b-form-input v-model="passType.days_limit" type="number"
                            placeholder="Days Limit"></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="isAdmin" label="Organisation" description="e.g. '7' for 7 day pass">
                        <b-form-select v-model="passType.organisation_id"
                            :options="organisations ? organisations.map(organisation => ({ value: organisation.id, text: organisation.name })) : []"
                            class="mb-3" />
                    </b-form-group>

                    <input type="file" style="display: none" ref=image accept="image/png,image/jpeg"
                        @change="onImageChange" />

                    <img v-if="imageUrl || passType.image" :src="imageUrl || getPassTypeImage" id="image" />


                    <b-button id="upload-pass-type" @click="showFilesToUpload">Upload Image</b-button>
                </b-col>
                <b-col cols="12" sm="12" md="8" lg="8" xl="8">
                    <h4>Facilities</h4>
                    <p v-if="!loading && (passType.organisations || []).length == 0">No facilities are enabled on this
                        pass type.</p>
                    <div v-for="org in passType.organisations">
                        <b-row>
                            <b-col>
                                <p>{{ org.organisation_name }}</p>
                            </b-col>
                            <b-col>
                                <b-form-group label="">
                                    <b-form-checkbox v-model="org.enabled" value="true" unchecked-value="false">
                                        Pass Enabled
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="">
                                    <b-form-checkbox v-model="org.accommodation_enabled" value="true"
                                        unchecked-value="false">
                                        Accomodation
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="">
                                    <b-form-checkbox v-model="org.buddy_day_enabled" value="true"
                                        unchecked-value="false">
                                        Buddy Day
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-button @click="goBack">Cancel</b-button>
            <b-button @click="save" variant="primary">Save<icon scale="1" v-show="saving" name="spinner" spin></icon>
            </b-button>
        </div>
    </div>
</template>

<script>
import api from '../api';
import config from "../constants";

var defaultPassTypeOrg = {
    accommodation_enabled: "false",
    buddy_day_enabled: "false"
}

export default {
    name: "PassTypeForm",
    props: ["passType"],
    data() {
        return {
            skuInput: this.passType.skus ? this.passType.skus.join(', ') : '',
            skuTags: this.passType.skus || [],
            ageOptions: [
                { value: 'Adult', text: 'Adult' },
                { value: 'Child', text: 'Child' },
                { value: 'Student', text: 'Student' },
                { value: 'Senior', text: 'Senior' },
                { value: 'Youth', text: 'Youth' },
                { value: 'Junior', text: 'Junior' },
                { value: 'Intermediate', text: 'Intermediate' },
                { value: 'Fully Paid', text: 'Fully Paid' },
                { value: 'Life', text: 'Life' },
                { value: 'Social', text: 'Social' }
            ],
            typeOptions: [
                { value: 'Season Pass', text: 'Season Pass' },
                { value: 'Travel Pass', text: 'Travel Pass' },
                { value: '30 Day Pass', text: '30 Day Pass' },
                { value: 'Member', text: 'Member' },
            ],
            organisations: null,
            newPassTypeOrg: defaultPassTypeOrg,
            validOrganisationsOptions: {},
            loading: true,
            saving: false,
            getAllOrgs: null,
            imageUrl: null,
            imageFile: null,
            isAdmin: api.userIsAdmin()
        };
    },
    computed: {
        isSeasonPass() {
            return /season/i.test(this.passType.type)
        }
    },
    created() {
        if (!this.getAllOrgs) {
            this.getAllOrgs = api.getAllOrganisations();
        }
    },
    updated() {
        this.loading = false
    },
    watch: {
        passType: {
            immediate: true,
            handler: function (newPassType) {
                console.log(this.passType);
                if (!this.getAllOrgs) {
                    this.getAllOrgs = api.userIsAdmin() ? api.getAllOrganisations().then(result => result.data.ret_msg)
                        : api.getOrganisationById(api.getUserOrganisationId())
                            .then(result => [result.data.ret_msg]);
                }
                if (!this.organisations) {
                    var that = this
                    that.getAllOrgs.then(organisations => {
                        that.organisations = organisations;
                        if (organisations.length && api.userIsAdmin()) {
                            const mtChill = organisations.find(organisation => organisation.name === 'Mt Chill');
                            if (mtChill && !this.passType.organisation_id) {
                                console.log('I made it here');
                                this.passType.organisation_id = mtChill.id;
                            }
                        }

                        this.addDummyPassOrgs()
                    })
                } else {
                    this.addDummyPassOrgs()
                }

                this.getSkuTags(this.passType.id);
            }
        },
    },
    methods: {
        updateSkuTags() {
            this.skuTags = this.skuInput
                .split(',')
                .map(s => s.trim())
                .filter(s => s.length > 0);
            this.passType.skus = this.skuTags;
        },
        sendUpdateSkuTags() {
            api.updateSkuTags(this.passType.id, this.skuTags).then(res => {
                console.log(res.data.ret_msg);
            });
        },
        getSkuTags(){
            api.getSkuTags(this.passType.id).then(res => {
                console.log(res.data.ret_msg);
                this.skuTags = res.data.ret_msg.split(',');
                this.skuInput = this.skuTags.join(', ');
            });
        },
        addDummyPassOrgs(passTypeOrgs) {
            var passTypeOrgs = this.passType.organisations.map(x => x.organisation_id)
            for (var key in this.passType.organisations) {
                var org = this.passType.organisations[key]
                org.enabled = "true"
            }
            for (var key in this.organisations) {
                var org = this.organisations[key]
                if (!passTypeOrgs.includes(org.id)) {
                    var dummy = Object.assign({
                        organisation_id: org.id,
                        organisation_name: org.name,
                        enabled: "false"
                    }, defaultPassTypeOrg);
                    this.passType.organisations.push(dummy)
                }
            }
            this.passType.organisations.sort(function (a, b) {
                var nameA = a.organisation_name.toLowerCase(), nameB = b.organisation_name.toLowerCase();
                if (nameA < nameB) {//sort string ascending
                    return -1
                }
                if (nameA > nameB) {
                    return 1
                }
                return 0 //default return value (no sorting)
            })
        },
        getValidPassOrgs() {
            if (!this.passType.organisations) {
                return this.organisations
            }
            var passTypeOrgs = this.passType.organisations.map(x => x.organisation_id)
            return this.organisations.filter(o => {
                // where it does not exist in pass_type's organisations
                return !passTypeOrgs.includes(o.id);
            })
        },
        save() {
            this.saving = true
            api.updateOrInsertPassType(this.passType, this.imageFile).then(res => {
                this.saving = false
                this.$router.push('/passtypes');
            }).catch(res => {
                alert('Something went wrong saving the pass type.')
            })
            this.sendUpdateSkuTags();
        },
        goBack() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/passtypes')
        },
        addFacility() {
            this.passType.organisations.push(
                {
                    organisation_id: this.newPassTypeOrg.organisation_id,
                    organisation_name: this.organisations.filter(x => x.id == this.newPassTypeOrg.organisation_id)[0].name,
                    accommodation_enabled: this.newPassTypeOrg.accommodation_enabled,
                    buddy_day_enabled: this.newPassTypeOrg.buddy_day_enabled,
                }
            )
            this.resetNewPassTypeOrg()
            this.validOrganisationsOptions = this.getValidPassOrgs()
        },
        resetNewPassTypeOrg() {
            this.newPassTypeOrg = {
                organisation_id: 0,
                accommodation_enabled: "false",
                buddy_day_enabled: "false"
            }
        },
        showFilesToUpload() {
            this.$refs.image.click();
        },
        onImageChange(event) {
            const files = event.target.files;
            const imageName = files[0].name;
            const splittedImageName = imageName.split(" ");

            const fileReader = new FileReader();

            fileReader.readAsDataURL(files[0]);
            fileReader.addEventListener("load", () => {
                this.imageUrl = fileReader.result;
                this.imageFile = files[0];
            });
        },

    },
    computed: {
        getPassTypeImage() {
            return `${config.passTypePhotosUrl}/${this.passType.image}`;
        }
    }
};
</script>

<style scoped>
#upload-pass-type {
    margin: 0 auto;
    display: block;
    margin-top: 20px;
}

#image {
    height: auto;
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PassTypeForm.vue